(function () {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var form = root.querySelector('[data-vin-form]'), inp = root.querySelector('[data-vin-input]');
    var cnt = root.querySelector('[data-vin-count]'), hint = root.querySelector('[data-vin-hint]'), res = root.querySelector('[data-vin-res]');
    var tpl = root.closest('section').querySelector('[data-vin-products]');
    var WMI = {
      WBA: ['BMW', 'Voiture'], WBS: ['BMW M', 'Voiture (BMW M GmbH)'], WBY: ['BMW i', 'Voiture électrique / hybride'], WBX: ['BMW', 'SUV (gamme X)'],
      '4US': ['BMW', 'Voiture produite aux États-Unis'], '5UX': ['BMW', 'SUV X produit aux États-Unis'], '5UM': ['BMW M', 'SUV X M produit aux États-Unis'], '5YM': ['BMW M', 'SUV X M produit aux États-Unis'],
      LBV: ['BMW', 'Produit en Chine (BMW Brilliance)'], X4X: ['BMW', 'Assemblé en Russie'],
      WMW: ['MINI', 'Voiture'], WMZ: ['MINI', 'Voiture'], WAP: ['BMW ALPINA', 'Voiture'], SCA: ['Rolls-Royce', 'Voiture'],
      WB1: ['BMW Motorrad', 'Moto'], WB3: ['BMW Motorrad', 'Moto'], WB4: ['BMW Motorrad', 'Moto'], WB5: ['BMW Motorrad', 'Moto']
    };
    var YR = 'ABCDEFGHJKLMNPRSTVWXY123456789';
    function clean(v) { return String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function year(c) {
      var i = YR.indexOf(c); if (i < 0) return null;
      var now = new Date().getFullYear() + 1, y = 1980 + i;
      while (y + 30 <= now) y += 30;
      return y;
    }
    function checkDigit(v) {
      var map = { A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8, J: 1, K: 2, L: 3, M: 4, N: 5, P: 7, R: 9, S: 2, T: 3, U: 4, V: 5, W: 6, X: 7, Y: 8, Z: 9 };
      var w = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2], s = 0;
      for (var i = 0; i < 17; i++) { var ch = v[i], n = /\d/.test(ch) ? +ch : map[ch]; s += n * w[i]; }
      var r = s % 11; return r === 10 ? 'X' : String(r);
    }
    inp.addEventListener('input', function () {
      var c = clean(inp.value).replace(/[IOQ]/g, '');
      if (c !== inp.value) { var p = inp.selectionStart; inp.value = c; try { inp.setSelectionRange(p, p); } catch (e) {} }
      cnt.textContent = c.length + '/17';
      cnt.classList.toggle('is-ok', c.length === 17);
    });
    function prods(list) {
      return '<div class="eculab-vin__prods">' + list.map(function (x) {
        var src = tpl && tpl.querySelector('[data-p="' + x[0] + '"]'); if (!src) return '';
        var c = src.cloneNode(true); c.querySelector('[data-why]').textContent = x[1];
        if (x[2]) c.classList.add('is-best');
        return c.outerHTML;
      }).join('') + '</div>';
    }
    function gen(g, isMini) {
      var box = res.querySelector('[data-gen-res]');
      var html = '';
      if (g === 'E') html = '<p class="eculab-vin__gtitle">' + (isMini ? 'MINI génération R (R50 à R61)' : 'BMW série E') + ' : prise OBD classique (K-Line / D-CAN)</p>' + prods([['kdcan', 'Diagnostic, codage INPA / NCS, flash avec logiciel compatible', true], ['bmwscan', 'Solution simple pour les anciennes BMW'], ['ista', 'Logiciel de diagnostic BMW officiel'], ['icom', 'Interface atelier, toutes générations']]);
      else if (g === 'F') html = '<p class="eculab-vin__gtitle">' + (isMini ? 'MINI génération F (F54 à F60)' : 'BMW série F / G') + ' : prise OBD Ethernet (ENET)</p>' + prods([['enet', 'Diagnostic et codage E-Sys / ISTA+, flash avec logiciel compatible', true], ['icom', 'Interface atelier : diagnostic et programmation'], ['ista', 'Logiciel de diagnostic BMW officiel']]);
      box.innerHTML = html;
      res.querySelectorAll('[data-gen]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.gen === g); });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = clean(inp.value);
      hint.classList.remove('is-err');
      if (v.length !== 17) { hint.textContent = 'Le VIN doit contenir exactement 17 caractères (actuellement ' + v.length + ').'; hint.classList.add('is-err'); return; }
      if (/[IOQ]/.test(v)) { hint.textContent = 'Un VIN ne contient jamais les lettres I, O ou Q : vérifiez la saisie (0 ou 1 ?).'; hint.classList.add('is-err'); return; }
      var w = WMI[v.slice(0, 3)];
      var y = year(v[9]);
      var na = /^[45]/.test(v);
      var cd = na ? checkDigit(v) === v[8] : null;
      var isMini = w && w[0] === 'MINI';
      var isMoto = w && /Motorrad/.test(w[0]);
      var rows = [
        ['Constructeur', w ? w[0] : 'Non reconnu (' + v.slice(0, 3) + ')'],
        ['Type', w ? w[1] : '—'],
        ['Code type (positions 4 à 7)', v.slice(3, 7)],
        ['Année-modèle', y ? y + ' <small>(indicative)</small>' : (v[9] === '0' ? 'Non codée <small>(normal sur un VIN européen)</small>' : '—')],
        ['Code usine', v[10]],
        ['N° de série', v.slice(11)],
        ['VIN court (7 derniers)', '<strong>' + v.slice(10) + '</strong> <small>utilisé par ISTA, E-Sys, NCS</small>']
      ];
      if (na) rows.push(['Chiffre de contrôle', cd ? 'Valide ✓' : 'Incorrect : vérifiez la saisie']);
      var html = '<div class="eculab-vin__vin">' + v.slice(0, 3) + '<span>' + v.slice(3, 9) + '</span>' + v.slice(9, 11) + '<b>' + v.slice(11) + '</b></div>';
      if (!w) html += '<p class="eculab-vin__warn">Ce VIN ne semble pas correspondre à un véhicule du groupe BMW (BMW, MINI, ALPINA, Rolls-Royce). Vérifiez la saisie.</p>';
      html += '<dl class="eculab-vin__dl">' + rows.map(function (r) { return '<div><dt>' + r[0] + '</dt><dd>' + r[1] + '</dd></div>'; }).join('') + '</dl>';
      if (w && !isMoto) {
        var guess = !y ? null : (isMini ? (y <= 2013 ? 'E' : 'F') : (y <= 2006 ? 'E' : y >= 2014 ? 'F' : null));
        html += '<div class="eculab-vin__gen"><p><strong>Quelle interface pour ce véhicule ?</strong> ' + (guess ? 'D’après l’année, il s’agit très probablement d’une ' + (guess === 'E' ? (isMini ? 'MINI génération R' : 'BMW série E') : (isMini ? 'MINI génération F' : 'BMW série F / G')) + '. Vous pouvez corriger :' : (y ? 'Entre 2007 et 2013, BMW a produit des séries E et F' : 'Ce VIN n’indique pas l’année') + ' : choisissez la génération. Le code châssis (ex. E90, F30, G20) figure sur l’étiquette du montant de porte ou dans ISTA.') + '</p>' +
          '<div class="eculab-vin__gbtns"><button type="button" data-gen="E">' + (isMini ? 'Génération R (R56, R60…)' : 'Série E (E46, E90, E60…)') + '</button><button type="button" data-gen="F">' + (isMini ? 'Génération F (F56, F60…)' : 'Série F / G (F30, G20…)') + '</button></div><div data-gen-res></div></div>';
      }
      res.innerHTML = html; res.hidden = false;
      hint.textContent = 'VIN analysé localement, rien n’est enregistré.';
      res.querySelectorAll('[data-gen]').forEach(function (b) { b.addEventListener('click', function () { gen(b.dataset.gen, isMini); }); });
      if (w && !isMoto) { var g0 = !y ? null : (isMini ? (y <= 2013 ? 'E' : 'F') : (y <= 2006 ? 'E' : y >= 2014 ? 'F' : null)); if (g0) gen(g0, isMini); }
      res.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }
  document.querySelectorAll('[data-vin]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-vin]').forEach(init); });
})();
